declare global {
  interface Window {
    dataLayer: any[];
  }
}

const GTMTracker = {
  initiate: () => {
    window.dataLayer = window.dataLayer || [];
  },
  record: (event) => {
    window.dataLayer.push(event.ga);
  },
};

export default GTMTracker;
